import { TEST_IDS } from '@va/constants';
import { Spinner } from '@va/icons';
import { useTranslate } from '@va/localization';
import { Button, Paragraph, TextInput } from '@va/ui/design-system';
import { useMemo } from 'react';
import { SenderEmailCreationStep, useSenderEmailCreationContext } from '../senderEmailCreationContext';

export const AddSenderNameStep = () => {
  const translate = useTranslate();

  const { setActiveStep, senderNameForm, onFinalConfirm, isLoadingFinalConfirm } = useSenderEmailCreationContext();
  const { values, handleChange, setFieldValue, errors, touched, handleBlur } = senderNameForm;

  const canSubmit = useMemo(() => {
    return values.senderName !== '' && !errors.senderName;
  }, [errors.senderName, values.senderName]);

  return (
    <div className='p-4 space-y-3'>
      <Paragraph>{translate('customSenderEmail.addSenderName.line1')}</Paragraph>

      <TextInput
        wrapperClassName='overflow-hidden grow'
        label={translate('customDomain.senderName.input.label')}
        placeholder={translate('customDomain.senderName.input.placeholder')}
        name='senderName'
        value={values.senderName}
        clearField={() => setFieldValue('senderName', '')}
        onChange={handleChange}
        onBlur={handleBlur}
        required
        error={(touched.senderName && errors.senderName) || undefined}
        showErrorMessage={false}
        bgColor='#F0F0F0'
        bgColorHover='#F9F9F9'
      />

      <div className='flex flex-row justify-end p-3 gap-3'>
        <Button
          className='rounded-12 flex-1'
          color='tertiary'
          text={translate('button.back')}
          onClick={() => {
            setActiveStep(SenderEmailCreationStep.verifyDNS);
          }}
          data-testid={TEST_IDS.generic.buttons.cancel}
        />
        <Button
          className='rounded-12 flex-2 justify-center'
          color='primary'
          icon={isLoadingFinalConfirm ? () => <Spinner /> : undefined}
          disabled={!canSubmit || isLoadingFinalConfirm}
          text={translate('button.confirmAndSaveChanges')}
          onClick={onFinalConfirm}
          data-testid={TEST_IDS.generic.buttons.apply}
        />
      </div>
    </div>
  );
};
